import { DownOutlined } from '@ant-design/icons';
import { useTypeSafeTranslation } from 'hooks';
import React from 'react';
import styles from './Header.module.less';

const Header = () => {
  const { t } = useTypeSafeTranslation();
  return (
    <>
      <div className={styles.root}>
        <div className={styles.radicalBg}>
          <div />
        </div>
        <div className={styles.particle} />
        <div className={styles.body}>
          <div>
            <h1>ORBS Special Page</h1>
            <div className="f-center">
              <img className={styles.logoLeft} src="/images/orbs-top-10/left.png" alt="left" />
              <img className={styles.logo} src="/images/orbs-top-10/banner.png" alt="orbs" />
              <img className={styles.logoRight} src="/images/orbs-top-10/right.png" alt="right" />
            </div>

            <h2>
              <span className="ocean">50%</span> of{' '}
              <span className="ocean">
                Ultorex Guardian <br /> Node Rewards
              </span>{' '}
              to the top{' '}
              <span className="ocean">
                <br />
                10 Stakers!
              </span>
            </h2>
          </div>

          <a href="#campaign">
            {t('campaign.let_go')}
            <DownOutlined />
          </a>
        </div>
      </div>
    </>
  );
};

export default Header;
